// i18n area 'common' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.ru-RU.meta.json.
import type { enUS } from './common'

export const ruRU: typeof enUS = {
  nav: {
    home: 'Главная',
    vms: 'Виртуальные машины',
    templates: 'Шаблоны',
    importVms: 'Импорт ВМ',
    containers: 'Контейнеры',
    containersApps: 'Приложения',
    containersPods: 'Поды',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Образы OCI',
    containersOciRegistries: 'Реестры OCI',
    containersCtTemplates: 'Шаблоны CT',
    networkServices: 'Сетевые службы',
    firewall: 'Брандмауэр',
    checkpoints: 'Контрольные точки',
    backup: 'Резервное копирование',
    monitoring: 'Мониторинг',
    cluster: 'Кластер',
    clusterSettings: 'Глобальные настройки',
    clusterNodes: 'Узлы',
    clusterDevices: 'Ресурсы USB и PCIe',
    clusterFederation: 'Федерация',
    network: 'Сеть',
    overlayNetworks: 'Оверлейные сети',
    fabric: 'Фабрика',
    ipam: 'IPAM',
    storage: 'Хранилище',
    data: 'Данные',
    storages: 'Хранилища',
    hci: 'Гиперконвергенция',
    ceph: 'Ceph',
    system: 'Система',
    tasks: 'Задачи',
    events: 'События',
    audit: 'Аудит',
    diagnostics: 'Диагностика',
    notifications: 'Уведомления',
    proximity: 'TVirt Proximity',
    users: 'Пользователи и группы',
    groups: 'Группы',
    mfa: 'MFA',
    realms: 'Реалмы и SSO',
    rbac: 'Роли и разрешения',
    credentials: 'Учетные данные',
    scopes: 'Скоупы',
    tags: 'Теги',
    explorer: 'Проводник',
    licensing: 'Лицензия',
    information: 'Информация'
  },
  mode: {
    light: 'Светлая',
    dark: 'Темная',
    system: 'Системная',
    tooltip: 'Тема'
  },
  language: {
    tooltip: 'Язык'
  },
  langRegion: {
    europe: 'Европа',
    northAmerica: 'Северная Америка',
    southAmerica: 'Южная Америка',
    asia: 'Азия'
  },
  notFound: {
    title: 'Страница не найдена',
    body: 'Этот адрес не соответствует ни одной странице TVirt — возможно, она переехала с обновлением или ссылка устарела.',
    backHome: 'Вернуться на главную'
  },
  scopeBrowser: {
    title: 'Скоупы',
    all: 'Весь кластер',
    noChildren: 'Здесь нет вложенных скоупов',
    recursive: 'Включая вложенные',
    collapse: 'Свернуть панель скоупов',
    openPicker: 'Обзор скоупов',
    up: 'На уровень выше',
    countTooltip: '{direct} в этом скоупе · {total} с вложенными'
  },
  search: {
    tooltip: 'Поиск (⌘K)',
    placeholder: 'Поиск ВМ, сетей, хранилищ…',
    empty: 'Ничего не найдено',
    groups: {
      recent: 'Недавние',
      shortcuts: 'Ярлыки',
      actions: 'Действия',
      goTo: 'Перейти'
    },
    kind: {
      catalog: 'Каталог',
      scope: 'Скоуп',
      node: 'Узел'
    },
    footer: {
      navigate: 'навигация',
      open: 'открыть',
      close: 'закрыть'
    },
    actions: {
      createVm: 'Создать ВМ…',
      uploadIso: 'Загрузить ISO…',
      clusterSettings: 'Настройки кластера',
      consoleOf: 'Перейти к консоли {name}'
    }
  },
  stub: {
    containersSummary: 'Приложения и системные контейнеры (CT) с их образами OCI, реестрами и шаблонами — управляются рядом с вашими ВМ.',
    sectionSummary_vms: 'Виртуальные машины и их шаблоны — жизненный цикл, снимки, миграция и консоль.',
    sectionSummary_storages: 'Хранилища, в которых живут диски, образы и метаданные ВМ.',
    sectionSummary_catalogs: 'Дом файловых артефактов кластера: образы ISO, шаблоны CT и ВМ, архивы OCI — разложенные по каталогам.',
    sectionSummary_overlay: 'Оверлейные сети VXLAN между узлами кластера.',
    sectionSummary_fabric: 'Инвентарь физической сети — коммутаторы, порты, LAGG и логические сети.',
    sectionSummary_ipam: 'Адресация, выведенная из сетей фабрики и оверлея: кто занимает каждый адрес.',
    sectionSummary_services: 'Серверы DHCP и DNS, выведенные из сетевого реестра.',
    sectionSummary_ceph: 'Кластеры Ceph под управлением на узлах TVirt.',
    sectionSummary_hci: 'Гиперконвергентные технологии хранения на узлах TVirt.',
    sectionSummary_cluster: 'Узлы, членство и настройки кластера.',
    containers: 'Системные контейнеры в дорожной карте — здесь они и появятся.',
    containersApps: 'Контейнеризованные приложения в дорожной карте — здесь они и появятся.',
    containersPods: 'Поды группируют контейнеры с общей сетью и томами — экземпляры и есть приложения.',
    containersCt: 'Системные контейнеры (CT) в дорожной карте — здесь они и появятся.',
    multiscsi: 'TVStor MultiSCSI в дорожной карте — здесь он и появится.',
    clusterFederation: 'Федерация между кластерами TVirt в дорожной карте — здесь она и появится.',
    containersOciImages: 'Образы OCI в дорожной карте — здесь они и появятся.',
    containersOciRegistries: 'Реестры OCI в дорожной карте — здесь они и появятся.',
    containersCtTemplates: 'Шаблоны CT в дорожной карте — здесь они и появятся.',
    importVms: 'Импортеры ESXi и Proxmox появятся здесь: конвертация гостевых систем и массовый перенос в TVirt.',
    backup: 'Встроенное резервное копирование выйдет в 6.2: дедуплицированные репозитории с адресацией по содержимому, инкременты на CBT, окна неизменяемости и репликация между репозиториями.',
    monitoring: 'Общекластерные панели по конкуренции за ресурсы (cpu.ready, давление PSI, встроенные оповещения) уже на подходе — сегодня те же метрики живут в деталях каждой ВМ.'
  },
  home: {
    welcome: 'Вы вошли под учетной записью: {name}',
    subtitle: 'Ваш кластер TVirt с одного взгляда.',
    loadError: 'Не удалось загрузить сводку — доступен ли бэкенд TVirt?',
    health: {
      ok: 'Все в порядке',
      warning: 'Требует внимания',
      critical: 'Критические проблемы'
    },
    reason: {
      'node-down': '{subject} выключен',
      'node-stale': '{subject} давно не давал о себе знать',
      'node-maintenance': '{subject} на обслуживании',
      'tasks-failed': {
        one: '{n} неудачная задача за последние 24 ч',
        few: '{n} неудачные задачи за последние 24 ч',
        many: '{n} неудачных задач за последние 24 ч',
        other: '{n} неудачной задачи за последние 24 ч'
      },
      'storage-degraded': 'хранилище {subject} деградировало',
      'storage-error': 'хранилище {subject} в состоянии ошибки',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'хранилище конфигурации кластера недоступно',
      'license-absent': 'лицензии нет — новые ВМ не смогут запуститься',
      'license-expired': 'срок лицензии истек — новые ВМ не смогут запуститься',
      'license-exceeded': 'превышен лимит лицензии — новые ВМ не смогут запуститься',
      'failover-reserve-eroded': 'резерв отказоустойчивости почти израсходован',
      'failover-reserve-exhausted': 'резерв отказоустойчивости исчерпан — новые ВМ не смогут запуститься',

      'oci-cache-nearly-full': 'кеш OCI на {subject} почти заполнен — дайджесты вытесняют вручную',
      'oci-cache-full': 'кеш OCI на {subject} заполнен — ни один pull не выполнится, пока дайджесты не вытеснят',
      'config-replica-empty': 'реплика конфигурации на {subject} ПУСТА — у узла нет конфигурации кластера, пока репликация не выполнится успешно',
      'config-replica-stalled': 'репликация конфигурации на {subject} остановилась — локальная копия отстаёт от конфигурации кластера'
    },
    staleChip: 'Данные устарели',
    staleAsOf: 'последняя реплика {time}',
    zone: {
      nodes: 'Узлы',
      failoverReserve: 'Резерв отказоустойчивости',
      capacity: 'Емкость',
      workload: 'Нагрузка',
      protection: 'Защита',
      activity: 'Последняя активность'
    },

    // Зона резерва отказоустойчивости (контроль допуска N+1, задача #133b).
    reserve: {
      state: {
        ok: 'Резерв в норме',
        eroded: 'Резерв почти израсходован',
        exhausted: 'Резерв исчерпан',
        unknown: 'Резерв неизвестен'
      },
      tolerate: {
        one: 'выдерживает потерю {n} узла',
        few: 'выдерживает потерю {n} узлов',
        many: 'выдерживает потерю {n} узлов',
        other: 'выдерживает потерю {n} узла'
      },
      usedOf: 'занято {used} / {allowed} GiB',
      keepFree: '{n} GiB оставлено свободными под отказоустойчивость',
      expendable: 'из них {n} жертвуемых в работе',
      headroom: 'запустить можно еще {n} GiB',
      short: 'резерву не хватает {n} GiB — новые ВМ не смогут запуститься',
      hp: {
        usedOf: 'Страницы по {size} — используется: {used} / {allowed}',
        keepFree: 'оставлено свободными под отказоустойчивость: {keep}',
        headroom: 'запустить можно еще: {n}',
        short: 'резерву не хватает: {n} — новые ВМ с огромными страницами не смогут запуститься'
      },
      worstCase: 'худший случай: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ни один узел еще не сообщил объем памяти — резерв рассчитать нельзя, и ни один запуск не отклоняется.',
      reason: {
        attestedDown: 'выключение подтверждено',
        maintenance: 'на обслуживании',
        unreachable: 'недоступен',
        capacityUnknown: 'память не заявлена'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} ядер / {threads} потоков',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} активная ВМ',
        few: '{n} активные ВМ',
        many: '{n} активных ВМ',
        other: '{n} активной ВМ'
      },
      activeVmsUnknown: 'число активных ВМ неизвестно',
      lastSeen: 'последний контакт {time}',
      neverSeen: 'ни разу не выходил на связь',
      down: 'Выключен',
      maintenance: 'Обслуживание',
      stale: 'Недоступен'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: 'выделено {n} GiB',
      reserve: 'резерв {n} GiB',
      unobserved: 'емкость еще не измерена',
      empty: 'Хранилищ пока нет'
    },
    workload: {
      vms: 'Виртуальные машины',
      apps: 'Приложения',
      services: 'Сетевые службы',
      empty: 'Пока пусто',
      phasesUnknown: 'разбивка по фазам недоступна'
    },
    protection: {
      none: 'Ни одной цели резервного копирования — защитите свою конфигурацию.',
      configure: 'Настроить контрольные точки',
      noRuns: 'Контрольная точка еще ни разу не создавалась.',
      last: 'Последняя контрольная точка',
      onTarget: 'на {target}',
      viewAll: 'Контрольные точки'
    },
    activity: {
      empty: 'Недавней активности нет',
      failed24: {
        one: '{n} неудачная за 24 ч',
        few: '{n} неудачные за 24 ч',
        many: '{n} неудачных за 24 ч',
        other: '{n} неудачной за 24 ч'
      },
      viewAll: 'Все задачи'
    }
  },
  notes: {
    title: 'Заметки',
    tabEdit: 'Редактирование',
    tabPreview: 'Предпросмотр',
    placeholder: 'Свободные заметки оператора — Markdown отображается в предпросмотре',
    empty: 'Заметок нет',
    tooLarge: 'Заметки превышают лимит в 64 KiB',
    saveError: 'Не удалось сохранить заметки'
  },
  common: {
    contractError: 'Ответ бэкенда содержит значение, неизвестное этому интерфейсу: {field}={value} — обнови веб-интерфейс до версии бэкенда.',
    contractErrorItems: '{count} объектов этого списка этот интерфейс не может прочитать ({field}={value}), и они не показаны.',
    staleHint: 'Хранилище конфигурации недоступно — это реплика конфигурации данного узла; состояние всего парка неизвестно.',
    staleStateAge: 'состояние на {time}',
    staleStateNever: 'состояние ни разу не получено из хранилища: вы видите только наблюдения этого узла',
    staleStateTooltip: 'Хранилище кластера недоступно: наблюдаемое состояние (фаза, узел, агент) берётся из реплики состояния этого узла и относится к последнему успешному чтению из хранилища — оно может быть устаревшим.',
    noPermission: 'У вас нет прав на это действие',
    actionStillRunning: 'Действие ещё выполняется — результат пока неизвестен',
    staleWrite: 'Кто-то другой изменил этот объект, пока вы его редактировали — ничего не записано. Перезагрузите и повторите изменение на актуальном состоянии.',
    staleReload: 'Перезагрузить',
    preview: 'Предпросмотр',
    previewTitle: 'Предпросмотр результата',
    previewNothingWritten: 'Смоделировано на сервере — ничего не записано.',
    previewChanged: 'Выделены значения, которые изменились бы.'
  },
  context: {
    copySelection: 'Копировать выделенный текст'
  },
  crud: {
    create: 'Создать',
    viewDetails: 'Просмотреть детали',
    viewOrEdit: 'Просмотреть или изменить',
    selected: 'выбрано',
    viewUsingVms: 'Показать ВМ, использующие ресурс',
    clearSelection: 'Снять выделение',
    deleteSelected: 'Удалить выбранные',
    bulkConfirmBody: {
      one: 'Удалить {count} выбранный элемент? Если он защищен, он будет отмечен и сохранен.',
      few: 'Удалить {count} выбранных элемента? Защищенные будут отмечены и сохранены.',
      many: 'Удалить {count} выбранных элементов? Защищенные будут отмечены и сохранены.',
      other: 'Удалить {count} выбранного элемента? Защищенные будут отмечены и сохранены.'
    },
    bulkDeleted: 'удалено',
    bulkRefused: 'отклонено',
    fieldId: 'ID',
    createdAt: 'Создано',
    updatedAt: 'Обновлено',
    immutableField: 'Задается при создании — контракт не допускает изменения',
    immutableScope: 'Скоуп назначается при создании; некоторые ресурсы переносятся отдельным действием',
    observedField: 'Наблюдаемое состояние — сообщается платформой, изменению не подлежит'
  }
}
